import Phaser from 'phaser'
export default class GameOverScene extends Phaser.Scene
{
    constructor()
    {
        super('GameOverScene')
    }

    init()
    {
        this.gameHalfWidth = this.scale.width * 0.5
        this.gameHalfHeight = this.scale.height * 0.5
        this.replayButton = undefined
    }
    
    preload()
    {
      this.load.image('Background2', 'images/Background_2.png')
      this.load.image('Ground', 'images/backbackground.png')
      this.load.image('Tilemap2', 'images/Tilemap_Background_2.png')
      this.load.image('GameOver', 'images/game-over.png')
      this.load.image('replayButton', 'images/TryAgain.png')
    }

    create()
    {
        this.add.image(this.gameHalfWidth, this.gameHalfHeight, 'Ground')
        const fight_bg = this.add.image(240, 160, 'Background2')
        const tile = this.physics.add.staticImage(240, fight_bg.height - 0, 'Tilemap2')
        this.add.image(240, 150, 'GameOver')
        this.replayButton = this.add.image(250, 500, 'replayButton').setScale(0.8).setInteractive()
        this.replayButton.once('pointerdown', () => {
            this.scene.start('EnemyBattlingScene') 
            }, this)
    }
}